import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface CourseAuditStateProps {
  auditLogsHeartbeatStarted: boolean
  courseAuditLogsCompleteData: any
  isSwayamClient: boolean
}

const initialState: CourseAuditStateProps = {
  isSwayamClient: false,
  auditLogsHeartbeatStarted: false,
  courseAuditLogsCompleteData: {
    event_id: "",
    widget_code: "spoken_english_assessment",
    action_performed: null,
    payload: {
      seg_id: "segment_no",
      input_params_obj: {
        topic: "topic_na",
        current_proficiency_level: "beginner",
        target_proficiency_level: "intermediate",
        difficulty_level: "medium",
        time_in_sec: 0,
        question_count: 3,
        rubric_criteria: ["rubric_criteria_no"],
        consider_history: false,
        custom_instructions: null,
      },
      assessment_obj: {
        topic: "topic_na",
        time_spent_seconds: 0,
        question_attempted: 0,
        questions_attempted: 0,
        questions_total: 3,
        areas_of_improvement: ["areas_of_improvement_na"],
        areas_of_strengths: ["areas_of_strengths_na"],
        overall_ai_feedback_text: "overall_ai_feedback_text_na",
        ques_details: [
          {
            ques_id: "ques_id_na",
            ques_text: "ques_text_na",
            ans_id: "ans_id_na",
            ans_text: "ans_text_na",
            ans_code: "ans_code_na",
            test_cases_given: 0,
            test_cases_passed: 0,
            ai_feedback_text: "ai_feedback_text_na",
            rubric_score: ["rubric_score_na"],
            overall_score: 0,
            user_response: "user_response_na",
            time_spent_seconds: 0,
            compute_time: 0,
            tokens_used: 0,
          },
        ],
        score: [{ ques1: 0 }, { ques2: 0 }, { ques3: 0 }],
        completion_status: "partial",
      },
      blob_uri: {
        complete_blob_uri: [],
        generated_blob_uri: [],
        uploaded_blob_uri: ["/client-recordings-artifacts/swayam/audio/"],
        downloaded_blob_uri: [],
      },
      compute_time: 0,
      tokens_used: 0,
      cache_hit: false,
      session_timeout: false,
      usage_time_in_sec: 0,
      watch_percentage: 0,
      video_duration: 0,
    },
  },
}

const CourseAuditSlice = createSlice({
  name: "swayam_course",
  initialState,
  reducers: {
    setAuditLogsHeartbeatStarted: (state, action: PayloadAction<boolean>) => {
      state.auditLogsHeartbeatStarted = action.payload
    },
    setCourseAuditLogsCompleteData: (state, action: PayloadAction<any>) => {
      state.courseAuditLogsCompleteData = action.payload
    },
    setIsSwayamClient: (state, action: PayloadAction<boolean>) => {
      state.isSwayamClient = action.payload
    },
    resetState: () => initialState,
  },
})

export const { resetState, setCourseAuditLogsCompleteData, setAuditLogsHeartbeatStarted, setIsSwayamClient } =
  CourseAuditSlice.actions
export default CourseAuditSlice.reducer
